/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Context_OverlineInputs */

const en_mk_context_overline = /** @type {(inputs: Mk_Context_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`04 · Context layer`)
};

const id_mk_context_overline = /** @type {(inputs: Mk_Context_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`04 · Lapisan konteks`)
};

/**
* | output |
* | --- |
* | "04 · Context layer" |
*
* @param {Mk_Context_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_context_overline = /** @type {((inputs?: Mk_Context_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Context_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_context_overline(inputs)
	return en_mk_context_overline(inputs)
});